import { Link } from "@/i18n/routing";
import { IconLinkArrow } from "@repo/assets/images";
import { CurrencySymbol } from "@repo/components";
import { getStrapiMedia } from "@repo/lib/utils";
import { Button, MotionContainer } from "@repo/ui";
import cx from "classnames";
import { getTranslations } from "next-intl/server";
import Image from "next/image";
const FavoriteCategories = async ({
  data
}) => {
  const t = await getTranslations("Common");
  const tCart = await getTranslations("Cart");
  const {
    title,
    link,
    subtitle,
    description,
    Card
  } = data || {};
  if (Card?.length === 0) return null;
  return <section className="bg-supportiveBlack w-full px-4 py-16 text-white" data-sentry-component="FavoriteCategories" data-sentry-source-file="FavoriteCategories.jsx">
      <div className="mx-auto md:max-w-screen-xl">
        {/* Header */}
        <div className="mb-8 flex flex-col items-stretch justify-between space-y-4 md:mb-12 md:flex-row md:space-y-0">
          <div className="flex flex-col items-start justify-between gap-4">
            {title && <MotionContainer delay={0.2}>
                <h2 className="text-lightYellow text-sm md:text-base">
                  {title}
                </h2>
              </MotionContainer>}
            {subtitle && <MotionContainer delay={0.4}>
                <h3 className="font-heading rtl:font-arabic text-2xl md:text-4xl">
                  {subtitle}
                </h3>
              </MotionContainer>}
          </div>
          <div className="ml-0 flex flex-col items-start justify-between gap-2 md:portrait:ml-1">
            {description && <MotionContainer delay={0.6}>
                <p className="text-sm font-normal text-white">{description}</p>
              </MotionContainer>}
            {link?.url && <MotionContainer delay={0.8}>
                <Link href={link?.url || "#"} className="text-lightYellow group flex items-center gap-2 transition-colors hover:text-[#F0B565]">
                  {t("View_All")}
                  <IconLinkArrow className="size-4 transition-transform duration-300 ease-in-out group-hover:translate-x-1 rtl:rotate-180 rtl:group-hover:-translate-x-1" />
                </Link>
              </MotionContainer>}
          </div>
        </div>

        {/* Grid Layout */}
        <div className="grid auto-rows-fr grid-cols-2 gap-4 lg:grid-cols-3">
          {Card?.map((card, index) => <div key={card?.id} className={cx("group relative overflow-hidden", {
          "col-span-2": (index + 1) % 5 === 0
        })}>
              <Link href={card?.url || "#"}>
                <MotionContainer className="h-full" delay={0.7 + index * 0.2}>
                  {card?.media?.url && <Image src={getStrapiMedia(card?.media?.url)} alt={card?.media?.alternativeText || card?.title} width={card?.media?.width} height={card?.media?.height} className="size-full object-cover transition-transform duration-300 group-hover:scale-110" />}
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent via-30% to-black/90 md:via-60%" />
                  <div className={cx("absolute bottom-0 left-0 right-0 flex p-2 text-white md:p-6", {
                "flex-row items-start justify-between": (index + 1) % 5 === 0,
                "flex-col md:flex-row md:items-end md:justify-between": (index + 1) % 5 !== 0
              })}>
                    <div className="mb-2 flex flex-col md:mb-0">
                      {card?.title && <h3 className="font-heading md:group-hover:text-lightYellow rtl:font-arabic text-sm md:text-2xl">
                          {card?.title}
                        </h3>}
                      {card?.subText && <span className="text-supportiveDarkGray flex items-center space-x-1 text-xs md:text-sm rtl:space-x-reverse">
                          <span>{t("Price_From")}</span>
                          <CurrencySymbol value={card?.subText} variant="smallSpecial" />
                        </span>}
                    </div>
                    {card?.url && <Button variant="primary" size="md">
                        {tCart("Shop_Now")}
                      </Button>}
                  </div>
                </MotionContainer>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
};
export default FavoriteCategories;